module.exports = "/_next/static/images/KyleClausen-20748e0756a92babbd2dbf6d43b1b0ce.webp";